module.exports = __webpack_public_path__ + "media/images/app/benefits/wardrobe-67ada5519a91e82acbdc5782c803d706.webp";